import { CheckBox, SquareRounded } from "@mui/icons-material";
import { Checkbox as MuiCheckbox, CheckboxProps, Radio as MuiRadio, RadioProps } from '@mui/material'

export const Checkbox = (props: CheckboxProps) => <MuiCheckbox icon={<SquareRounded sx={{ color: "grey.300"}}/>} checkedIcon={<CheckBox/>} {...props}/>
export const Radio = (props: RadioProps) => <MuiRadio {...props}/>